import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 48 48",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(2,0,0,2,0,0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0.75 23.249L23.25 0.749",
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			d: "M23.25 23.249L0.75 0.749",
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})]
	})
});
export { SvgClose as ReactComponent };
